import { render } from "./EventActionsGroup.vue?vue&type=template&id=e8718ee8&scoped=true"
import script from "./EventActionsGroup.vue?vue&type=script&lang=ts"
export * from "./EventActionsGroup.vue?vue&type=script&lang=ts"

import "./EventActionsGroup.vue?vue&type=style&index=0&id=e8718ee8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e8718ee8"

export default script